import { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { apiFetch } from '../services/auth'
import { UserProfile } from './UserProfile'

interface FortnoxStatus {
  isConnected: boolean
  companyName?: string
  lastSync?: string
}

function FortnoxStatusCard() {
  const [status, setStatus] = useState<FortnoxStatus | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const checkFortnoxStatus = async () => {
      try {
        const response = await apiFetch('/fortnox/status')

        if (response.ok) {
          const statusData = await response.json()
          setStatus(statusData)
        }
      } catch (error) {
        // console.error('Error checking Fortnox status:', error)
      } finally {
        setIsLoading(false)
      }
    }

    checkFortnoxStatus()
    }, [])

  if (isLoading) {
    return (
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e2e8f0',
        marginBottom: '24px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            backgroundColor: '#00a651',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <span style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>F</span>
          </div>
          <div>
            <h3 style={{ margin: '0 0 4px 0', color: '#1a202c', fontSize: '16px', fontWeight: '600' }}>
              Fortnox Status
            </h3>
            <p style={{ margin: 0, color: '#64748b', fontSize: '14px' }}>
              Kontrollerar anslutning...
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0',
      marginBottom: '24px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
        <div style={{
          width: '40px',
          height: '40px',
          backgroundColor: '#00a651',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <span style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>F</span>
        </div>
        <div>
          <h3 style={{ margin: '0 0 4px 0', color: '#1a202c', fontSize: '16px', fontWeight: '600' }}>
            Fortnox Status
          </h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: status?.isConnected ? '#16a34a' : '#dc2626'
            }} />
            <span style={{
              color: status?.isConnected ? '#16a34a' : '#dc2626',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              {status?.isConnected ? 'Ansluten' : 'Ej ansluten'}
            </span>
          </div>
        </div>
      </div>
      
      {status?.isConnected && (
        <div style={{ paddingLeft: '52px' }}>
          {status.companyName && (
            <p style={{ margin: '0 0 4px 0', color: '#64748b', fontSize: '13px' }}>
              Företag: {status.companyName}
            </p>
          )}
          {status.lastSync && (
            <p style={{ margin: 0, color: '#64748b', fontSize: '13px' }}>
              Senaste synk: {new Date(status.lastSync).toLocaleString('sv-SE')}
            </p>
          )}
        </div>
      )}
    </div>
  )
}

export function Overview() {
  const { user } = useAuth()

  return (
    <div>
      <h2 style={{ marginBottom: '24px', color: '#1a202c' }}>
        Välkommen tillbaka, {user?.displayName || user?.name}
      </h2>
      
      <FortnoxStatusCard />
      <UserProfile />
    </div>
  )
}
